import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IIdeaGenQuery } from '../../core/models/idea-generation.model';

@Injectable({
  providedIn: 'root',
})
export class IdeaGenStateService {
  private activeRequests = 0;
  private disableButtonsSubject = new BehaviorSubject<boolean>(false);
  disableButtons$ = this.disableButtonsSubject.asObservable();

  private querySubject = new BehaviorSubject<IIdeaGenQuery>({
    date_end: null,
  });
  query$ = this.querySubject.asObservable();

  setQuery(query: IIdeaGenQuery) {
    this.querySubject.next(query);
  }

  incrementActiveRequests() {
    this.activeRequests += 1;
    this.updateDisableButtons();
  }

  decrementActiveRequests() {
    if (this.activeRequests > 0) {
      this.activeRequests -= 1;
      this.updateDisableButtons();
    }
  }

  private updateDisableButtons() {
    this.disableButtonsSubject.next(this.activeRequests > 0);
  }
}
